import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import cn from 'classnames'
import {PaymentMethod} from '@raisenow/epik'
import {useStores} from '../../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../../lib/WidgetApi'
import {DynamicSlotName} from '../../../../../lib/DynamicSlotName'
import {ErrorMessage} from '../../../../ui/ErrorMessage'
import {DynamicSlot} from '../../../../dynamic/DynamicSlot'
import {PaymentForm} from '../../../../../lib/forms/PaymentForm'
import {SubscriptionRenewForm} from '../../../../../lib/forms/SubscriptionRenewForm'
import {InfoToggle} from '../../../../ui/InfoToggle'
import {InputWrapper} from '../../../../wrappers/InputWrapper'
import {DirtyWrapper} from '../../../../wrappers/DirtyWrapper'

///////////////////////////////////////////////////////////////////////////////

export type SepaOneFormProps = {
  form: PaymentForm | SubscriptionRenewForm
}

///////////////////////////////////////////////////////////////////////////////

export const SepaOneForm: FC<SepaOneFormProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {form} = props
  const formData = form.data
  const errors = form.validationErrors

  const bankiban = formData.bankiban || ''
  const bankbic = formData.bankbic || ''
  const setBankiban = (value) => (formData.bankiban = value)
  const setBankbic = (value) => (formData.bankbic = value)

  const showBankbic = api.resolveConfigWithSingleResult<boolean>('showBankbic')

  const infoToggleTitle = api.trans('info_toggle.sod.title', {
    defaultValue: null,
  })
  const infoToggleTextHTML = api.trans('info_toggle.sod.text_html', {
    defaultValue: null,
  })

  return (
    <div className={cn('payment-method-form', PaymentMethod.SEPA_ONE)}>
      <DynamicSlot name={DynamicSlotName.SEPA_ONE_FORM_START} form={form} />

      <div className="main">
        <div className="form-block bankiban">
          <div className="field-block">
            <label
              className="label-block"
              htmlFor={api.ui.generateUniqueElementId('bankiban')}
            >
              {api.trans('payment_form.bankiban')}
            </label>
            <InputWrapper form={form} fields="bankiban">
              <DirtyWrapper form={form} fields="bankiban">
                <input
                  type="text"
                  id={api.ui.generateUniqueElementId('bankiban')}
                  aria-describedby={api.ui.generateUniqueElementId(
                    'bankiban-error',
                  )}
                  className="input-text"
                  value={bankiban}
                  onChange={(e) => setBankiban(e.target.value)}
                  autoCapitalize="characters"
                  placeholder={api.trans('payment_form.placeholders.bankiban')}
                />
              </DirtyWrapper>
            </InputWrapper>
          </div>

          <ErrorMessage
            errors={errors}
            errorKey="bankiban"
            id={api.ui.generateUniqueElementId('bankiban-error')}
          />
        </div>

        <DynamicSlot name={DynamicSlotName.SEPA_ONE_FORM_1} form={form} />

        {showBankbic && (
          <div className="form-block bankbic">
            <div className="field-block">
              <label
                className="label-block"
                htmlFor={api.ui.generateUniqueElementId('bankbic')}
              >
                {api.trans('payment_form.bankbic')}
              </label>
              <InputWrapper form={form} fields="bankbic">
                <DirtyWrapper form={form} fields="bankbic">
                  <input
                    type="text"
                    id={api.ui.generateUniqueElementId('bankbic')}
                    aria-describedby={api.ui.generateUniqueElementId(
                      'bankbic-error',
                    )}
                    className="input-text"
                    value={bankbic}
                    onChange={(e) => setBankbic(e.target.value)}
                    autoCapitalize="characters"
                    placeholder={api.trans('payment_form.placeholders.bankbic')}
                  />
                </DirtyWrapper>
              </InputWrapper>
            </div>

            <ErrorMessage
              errors={errors}
              errorKey="bankbic"
              id={api.ui.generateUniqueElementId('bankbic-error')}
            />
          </div>
        )}
      </div>

      <InfoToggle
        idKey="info-toggle-sod"
        className={cn('info-toggle-pm', 'info-toggle-sod')}
        title={infoToggleTitle}
        textHTML={infoToggleTextHTML}
      />

      <DynamicSlot name={DynamicSlotName.SEPA_ONE_FORM_END} form={form} />
    </div>
  )
})
